import React, { FC } from 'react'
import { HeroProps } from 'src/components/Hero/types'

import { MainLayoutProps } from '../../layouts'
import Breadcrumb, { BreadcrumbProps } from '../../components/Breadcrumb'
import SearchResults, {
  SearchResultsProps,
} from '../../components/SearchResults'

import * as SC from './styled'

export type SearchResultsTemplateProps = MainLayoutProps & {
  hero?: HeroProps
  children?: React.ReactNode
  breadcrumbProps?: BreadcrumbProps
  searchResultsProps?: SearchResultsProps
}

const SearchResultsTemplate: FC<SearchResultsTemplateProps> = ({
  children,
  hero,
  breadcrumbProps,
  searchResultsProps,
  ...layoutProps
}) => {
  return (
    <SC.Layout {...layoutProps}>
      <SC.Top>
        {hero && <SC.Hero {...hero} />}
        <Breadcrumb {...breadcrumbProps} />
      </SC.Top>
      <SearchResults {...searchResultsProps} />
      {children}
    </SC.Layout>
  )
}

export default SearchResultsTemplate
